import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";

angular
  .module('bringoz.admin.ruleEngine')
  .factory('$ruleEngine', ruleEngineObjectFactory);

/* @ngInject */
function ruleEngineObjectFactory($bringozFactory: $bringozFactory,
                                 ruleEngineAPI: BringozApi,
                                 Rule_Engine_DS: DataStoreConfig) {

  function $ruleEngine(id: string) {
    return $bringozFactory(id, ruleEngineAPI, Rule_Engine_DS)
  }

  return $ruleEngine;

}
